import React, { useContext, useEffect, useMemo } from "react";
import { CommonService } from "../../services/common/common.service";
import HeaderComponent from "../../components/header/header.component";
import { GlobalContext, UsersProvider } from "../../store";
import UsersContent from "../../modules/users/components/users-content/users-content.component";
import { useTranslation } from "react-i18next";
import { ContentLayout } from "../../layouts/content/content.layout";
import PagesHeadComponent from "../../components/pages-head-component/pages-head.component";
import SupportBlockComponent from "../../components/support/support.component";

export default function UsersPage() {
  const { t } = useTranslation();
  const commonService = useMemo(() => new CommonService(), []);
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    const title = t("PAGE_META_TITLES.USER_MANAGEMENT");
    commonService.setTitle(title);
    setPageTitle(title);
  }, [t, setPageTitle, commonService]);

  return (
    <UsersProvider>
      <HeaderComponent />
      <ContentLayout>
        <PagesHeadComponent
          title={t("PAGES_HEAD.USERS_MANAGEMENT_TITLE")}
          subTitle={t("PAGES_HEAD.USERS_MANAGEMENT_SUB_TITLE")}
        />
        <UsersContent />
        <SupportBlockComponent />
      </ContentLayout>
    </UsersProvider>
  );
}
